(function () {
    if (window.__bellacashInit) return;
    window.__bellacashInit = true;
  
    document.addEventListener("click", function (e) {
      const toggle = e.target.closest("#toggleSlider");
      const close = e.target.closest("#closeSlider");
      const overlay = e.target.closest("#sliderOverlay");
  
      const slider = document.getElementById("bottomSlider");
      const overlayEl = document.getElementById("sliderOverlay");
      const closeBtn = document.getElementById("closeSlider");
  
      if (!slider || !overlayEl || !closeBtn) return;
  
      // OPEN
      if (toggle) {
        slider.classList.add("active");
        overlayEl.classList.add("active");
        closeBtn.classList.add("show");
        document.body.classList.add("overflow-hidden");
        return;
      }
  
      // CLOSE
      if (close || overlay) {
        slider.classList.remove("active");
        overlayEl.classList.remove("active");
        closeBtn.classList.remove("show");
        document.body.classList.remove("overflow-hidden");
      }
    });
  
  })();

  
